import { render, staticRenderFns } from "./Criteria.vue?vue&type=template&id=0d3853ba&scoped=true"
import script from "./Criteria.vue?vue&type=script&lang=js"
export * from "./Criteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3853ba",
  null
  
)

export default component.exports